import  { FC } from "react";
import { DetailRow } from "../../../helpers/utils/OrderDetailUtils";
import { useGetCustomerByIdQuery } from "../../customer/customerApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetBranchByIdQuery } from "../../customer/branchApi";
import { getEnumDisplayNameByConstant } from "../../../helpers/utils/EnumUtils";
import { useGetEnumsQuery } from "../../../app/globalApi";
import {  formatValueAsDateAndTime } from "../../../helpers/utils/DateUtils";
import { useSelector } from "react-redux";

interface props {
    orderQuery: { data: any, isLoading: boolean, isError: boolean } | any,
}

const OrderDetailInfo: FC<props> = ({ orderQuery }) => {
    const {
        data: customerData,
        isLoading: isCustomerLoading,
        isError: isCustomerError
    } = useGetCustomerByIdQuery(orderQuery?.data?.customerId || skipToken);
    const { data: enums } = useGetEnumsQuery("");
    let customerUploadedDocuments = useSelector((state: any) => state.getCustomerUploadedDocumentsReducer);

    const {
        data: branchData,
        isLoading: isBranchLoading,
        isError: isBranchError,
    } = useGetBranchByIdQuery(orderQuery?.data?.branchId ? {
        branchId: orderQuery?.data?.branchId
    } : skipToken);

    return (
        <>
            <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md relative">
                <div className='arrow_buttons order_detail_show mt-0 flex gap-3 top-0 right-2 text-right absolute'>
                    {orderQuery.data && orderQuery.data.error === undefined ? orderQuery?.data?.properties && orderQuery?.data?.properties?.length > 1 &&
                        <div className="">
                            <button className="bg-[#ffc107] px-[8px] py-[10px] inline-block text-black text-sm font-normal relative rounded-none border-none
                        before:content-[''] before:absolute before:bottom-[-15px] before:left-0 before:right-0 before:m-auto before:w-0 before:h-0 before:border-l-[25px] before:border-l-[rgba(0,0,0,0)] before:border-r-[25px] before:border-r-[rgba(0,0,0,0)] before:border-t-[16px] before:border-t-[#ffc107]
                        ">Multi
                            </button>
                        </div> : null}
                    {orderQuery.data && orderQuery.data.error === undefined ? orderQuery.data.rushDate != null &&
                        <div className=" ">
                            <button title={formatValueAsDateAndTime(String(orderQuery.data.rushDate)) ?? "0"} className="bg-[#ff9800] px-[8px] py-[10px] inline-block text-black text-sm font-normal relative rounded-none border-none
                before:content-[''] before:absolute before:bottom-[-15px] before:left-0 before:right-0 before:m-auto before:w-0 before:h-0 before:border-l-[25px] before:border-l-[rgba(0,0,0,0)] before:border-r-[25px] before:border-r-[rgba(0,0,0,0)] before:border-t-[16px] before:border-t-[#ff9800]
                ">Rush
                            </button>
                        </div>

                        : null}
                    {orderQuery.data && orderQuery.data.error === undefined ? customerUploadedDocuments?.items?.length > 0 &&
                        <button className='arrow_down3 mr-2' title={"Customer has uploaded documents"}>Doc
                        </button> : null}
                </div>
                <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
                    <h3 className="font-semibold text-surface-0">Order Detail</h3>
                </div>

                <div className="p-3">
                    <DetailRow label="Order No."
                        value={orderQuery?.data?.customerOrderNumber}
                        isLoading={orderQuery?.isLoading}
                        isError={orderQuery?.isError} />

                    <DetailRow label="Customer"
                        value={customerData?.customerName}
                        isLoading={isCustomerLoading || orderQuery?.isLoading}
                        isError={isCustomerError} />

                    <DetailRow label="Branch"
                        value={branchData?.displayLabel || branchData?.name}
                        isLoading={isBranchLoading || orderQuery?.isLoading}
                        isError={isBranchError} />


                    <DetailRow label="Closing Agent"
                        value={orderQuery?.data?.closingAgent?.email}
                        isLoading={orderQuery?.isLoading}
                        isError={orderQuery?.isError} overrideValue={orderQuery?.data?.closingAgent?.email ? <a className={"text-highlight-4"} href={`mailto:${orderQuery?.data?.closingAgent?.email}`}>{orderQuery?.data?.closingAgent?.email}</a> : '-'} />

                    <DetailRow label="Status"
                        value={getEnumDisplayNameByConstant(enums?.["OrderStatus"], orderQuery?.data?.orderStatus)}
                        isLoading={orderQuery?.isLoading}
                        isValueSpan={true} />

                    <DetailRow
                        label="Created by"
                        isLoading={orderQuery?.isLoading}
                        value={orderQuery?.data && orderQuery?.data?.createdBy} />

                    <DetailRow
                        label="Order Date"
                        isLoading={orderQuery?.isLoading}
                        value={orderQuery?.data && formatValueAsDateAndTime(orderQuery?.data?.creationDate)}
                    />

                    <DetailRow
                        label="Closing Date"
                        isLoading={orderQuery?.isLoading}
                        value={orderQuery?.data && formatValueAsDateAndTime(orderQuery?.data?.closingDate)}
                    />

                    <DetailRow label="Needed by"
                        isLoading={orderQuery?.isLoading}
                        value={formatValueAsDateAndTime(orderQuery?.data?.needByDate) || "-"}
                    />
                    <DetailRow
                        label="Partner"
                        value={orderQuery?.data && orderQuery?.data?.orderSource}
                        isValueSpan={true}
                        isLoading={orderQuery?.isLoading}
                        className="!bg-[#28A745]"
                    />
                </div>

            </div>
        </>
    )

}
export default OrderDetailInfo;